<div #mainView id="view" class="view--layout">
  <header id="header" class="header">
    <fl-top-menu
      [notifications]="notifications()"
      [filteredOutNotificationCount]="filteredOutNotificationCount()"
      [breadcrumbs]="breadcrumbs()"
      [vessels]="vessels()"
      [isLoadingVessels]="isLoadingVessels()"
      [fleets]="fleets()"
      [(selectedFleetIds)]="selectedFleetIds"
      [user]="user()"
      [userRole]="userRole()"
      [userCustomRoleName]="userCustomRoleName()"
      [timezone]="timezone()"
      [licenses]="licenses()"
      [permissions]="permissions()"
      [tenant]="tenant()"
      [userCompanyName]="userCompanyName()"
      [(selectedVesselId)]="selectedVesselId"
      (consentClick)="consentClick.emit()"
      (logoutClick)="logoutClick.emit()"
      (notificationsRead)="notificationsRead.emit()"
    />
  </header>

  <!-- Side menu -->
  <aside id="sidemenu" class="sidemenu" [class.minimized]="isSideMenuMinimized()">
    <fl-side-menu [items]="sideMenuItems()" [(isMinimized)]="isSideMenuMinimized" />
  </aside>

  <!-- Main -->
  <main id="main" class="main" [class.minimized]="isSideMenuMinimized()">
    <router-outlet />
  </main>
</div>
